module.exports = __webpack_public_path__ + "components/country-flag/static/us-ff79de9a2b6fd8944ba58dc5b1b6e456.svg";